// @ts-check
import { customRef } from 'vue';

/**
 * @template T
 * @param {T} initialValue
 * @param {() => void} [callback]
 * @returns {import('vue').Ref<T>}
 */
export function useCustomRef(initialValue, callback) {
  let value = initialValue;

  return customRef((track, trigger) => ({
    get() {
      track();
      return value;
    },
    set(newValue) {
      value = newValue;
      trigger();

      if (callback) {
        callback();
      }
    },
  }));
}
